// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"cfabb115","821":"7b3b2b1a","946":"65568695"}[chunkId] + ".chunk.js";
};